import { T } from '@territory/tokens';

/*
 * The shipped Wedge press ring (.wedge-scope .wedge-pressable:active, .wedge-hoverable:active in wedgeStyles). Core focusRing()
 * sets outline none on a mouse or touch press (focus without focus-visible) and ties that ring on specificity, so a wedge look
 * restates the ring after it. Gated on the two shipped classes, as the shipped rule is, so an unclassed control draws none.
 */
export function wedgePressRing(selector: string): string {
  return `${selector}:is(.wedge-pressable, .wedge-hoverable):focus:not(:focus-visible):active { outline: 2px solid color-mix(in srgb, ${T.accent} 60%, transparent); outline-offset: 1px; }`;
}
